import introJs from 'intro.js';
import 'intro.js/introjs.css';

export function startCampaignWizardTour(onComplete: () => void) {
    // 🔒 Bloqueo centralizado por variable de entorno
    if (process.env.REACT_APP_ENABLE_POST_TOUR === 'false' || process.env.REACT_APP_ENABLE_POST_TOUR === '0') {
        onComplete();
        return;
    }
    const intro = introJs();

    const titleStyle = 'margin:0 0 6px;font-size:16px;font-weight:700;color:#f8fafc;letter-spacing:-0.2px;display:flex;align-items:center;gap:6px';
    const textStyle = 'margin:0;color:#94a3b8;font-size:13px;line-height:1.55';

    // Construimos los pasos filtrando preventivamente si no encuentran a su receptor 
    // en el DOM (para evitar que un error rompa toda la vista, como ocurrió).
    const rawSteps = [
        {
            el: document.getElementById('tour-card-Marketing'),
            intro: `
                <div style="${titleStyle}">📣 Marketing</div>
                <p style="${textStyle}">Aquí programas un <strong>único envío con una fecha específica</strong>. Ideal para enviar promociones, ofertas de Black Friday, o novedades puntuales a tus clientes.</p>
            `,
            position: 'right' as const
        },
        {
            el: document.getElementById('tour-card-Renovación-de-servicio'),
            intro: `
                <div style="${titleStyle}">🔄 Recordatorios Periódicos</div>
                <p style="${textStyle}">Sirve para <strong>cobros con periodicidad</strong>. Agregas la fecha central de vencimiento y Rebeca enviará recordatorios automáticos (Ejemplo: pago mensual de colegiaturas, Netflix, o vencimiento de SOAT anual).</p>
            `,
            position: 'right' as const
        },
        {
            el: document.getElementById('tour-card-Dynamic'),
            intro: `
                <div style="${titleStyle}">⚡ Campaña Dinámica</div>
                <p style="${textStyle}">Múltiples fechas variables. Perfecto <strong>si tienes citas</strong> (ej: odontología, reuniones) donde cada persona tiene un día diferente en tu hoja de cálculo.</p>
            `,
            position: 'right' as const
        },
        {
            el: document.getElementById('tour-input-name'),
            intro: `
                <div style="${titleStyle}">✍️ ¡Ponle un Nombre!</div>
                <p style="${textStyle}">Elige tu tipo de campaña arriba, luego <strong>asígnales un nombre</strong> aquí abajo para reconocerla, y presiona el botón principal azul para continuar.</p>
            `,
            position: 'top' as const
        }
    ];

    const finalSteps = rawSteps.filter(s => !!s.el).map(s => ({
        element: s.el!,
        intro: s.intro,
        position: s.position
    }));

    if (finalSteps.length === 0) {
        onComplete();
        return;
    }

    intro.setOptions({
        steps: finalSteps,
        showProgress: true,
        showBullets: true,
        showStepNumbers: false,
        doneLabel: '¡Entendido!',
        nextLabel: 'Siguiente →',
        prevLabel: '← Atrás',
        exitOnOverlayClick: false,
        exitOnEsc: false,
        disableInteraction: true // Bloquea los clicks subyacentes asegurando que el foco sea solo en leer.
    });

    intro.oncomplete(onComplete);
    intro.onexit(onComplete);

    intro.start();
}
